export const aggravates = {
  footAnkle: [
    { en: 'Touch your foot or ankle', es: 'Toca tu pie o tobillo' },
    {
      en: 'Flex or extend your ankle',
      es: 'Flexiona o extiende tu tobillo',
    },
    { en: 'Stand or walk', es: 'Ponte de Pie o camina' },
    {
      en: 'First steps after resting',
      es: 'Primeros pasos después de descansar',
    },
    { en: 'Run', es: 'Corre' },
    { en: 'Pivot or twist', es: 'Pivote o gira' },
    { en: 'Stand tip-toe', es: 'Párate de puntillas' },
    { en: 'Walk stairs or hills', es: 'Caminar escaleras o colinas' },
  ],
  kneeLeg: [
    { en: 'Touch your leg', es: 'Contacto con la pierna' },
    {
      en: 'Flex or extend your knee',
      es: 'Flexionar o extender la rodilla',
    },
    { en: 'Kneel', es: 'Arrodillarme' },
    {
      en: 'Arise after sitting',
      es: 'Levantarme despues de estar sentado',
    },
    { en: 'Stand or walk', es: 'Pararme o caminar' },
    { en: 'Run', es: 'Correr' },
    { en: 'Pivot or twist', es: 'Girar' },
    { en: 'Walk stairs or hills', es: 'Subir escaleras o colinas' },
    { en: 'Deep squat', es: 'Sentarme' },
    { en: 'Jump', es: 'Saltar' },
  ],
  hip: [
    { en: 'Touch your hip', es: 'Toca tu cadera' },
    { en: 'Lay on your hip', es: 'Acuéstate de lado' },
    { en: 'Bring your knee to your chest', es: 'Lleva tu rodilla al pecho' },
    { en: 'Long strides when walking', es: 'Zancadas largas al caminar' },
    {
      en: 'Cross your legs, i.e., put socks on',
      es: 'Cruza las piernas, es decir, ponerse los calcetines',
    },
    { en: 'Spread your legs', es: 'Abre las piernas' },
    {
      en: 'Get in and out of a vehicle',
      es: 'Entrar y salir de un vehículo',
    },
    { en: 'Arise after sitting', es: 'Levántate después de sentarte' },
    { en: 'Sitting or car rides', es: 'Sentarse o paseos en carro' },
    { en: 'Stand or walk', es: 'Pararse o Caminar' },
    { en: 'Run', es: 'Correr' },
    { en: 'Walk stairs or hills', es: 'Caminar escaleras o colinas' },
    { en: 'Kick', es: 'Patear' },
    { en: 'Squeeze your thighs together', es: 'Aprieta los muslos juntos' },
  ],
  back: [
    { en: 'Bend or lean forward', es: 'Inclínate hacia adelante' },
    { en: 'Bend or lean backward', es: 'Inclínate hacia atrás' },
    {
      en: 'Twist or bend, i.e. roll in bed',
      es: 'Girar o doblarse, i.e. dar la viuelta en la cama',
    },
    { en: 'Sitting or car rides', es: 'Sentarse o paseos en carro' },
    { en: 'Stand or walk', es: 'Párate o camina' },
    { en: 'Cough or sneeze', es: 'Toser o estornudar' },
    {
      en: 'Get in and out of a vehicle',
      es: 'Entrar y salir de un vehículo',
    },
    { en: 'Arise after sitting', es: 'Levántate después de sentarte' },
  ],
  backRib: [
    { en: 'Bend or lean forward', es: 'Inclínate hacia adelante' },
    {
      en: 'Extend or lean backward',
      es: 'Extiende hacia atrás o inclínate hacia atrás',
    },
    {
      en: 'Twist or bend, i.e. roll in bed',
      es: 'Girar o doblar hacia un lado',
    },
    { en: 'Move your head & neck', es: 'Mover la cabeza y el cuello' },
    { en: 'Sitting or car rides', es: 'Sentado o paseos en carro' },
    { en: 'Stand or walk', es: 'Párate o camina' },
    { en: 'Breathe', es: 'Respira' },
    { en: 'Cough or sneeze', es: 'Toser o estornudar' },
    { en: 'Push or pull', es: 'Empujar o tirar' },
  ],
  neck: [
    { en: 'Move your head & neck', es: 'Mover la cabeza y el cuello' },
    { en: 'Look down', es: 'Mirar hacia abajo' },
    { en: 'Look up', es: 'Mirar hacia arriba' },
    { en: 'Turn your head', es: 'Girar tu cabeza' },
    { en: 'Use your arms', es: 'Usar tus brazos' },
    { en: 'Cough or sneeze', es: 'Toser o estornudar' },
    {
      en: 'Workstation use (prolonged look down)',
      es: 'Uso de la estación de trabajo (mirada prolongada hacia abajo)',
    },
    {
      en: 'Overhead work',
      es: 'Actividades que requieren movimientos por encima de tu cabeza',
    },
    { en: 'Drive', es: 'Conducir' },
    { en: 'Sleep', es: 'Dormir' },
  ],
  elbowForearm: [
    { en: 'Touch your elbow', es: 'Toca tu codo' },
    { en: 'Flex or bend your elbow', es: 'Flexiona o dobla el codo' },
    {
      en: 'Fully straighten your elbow',
      es: 'Endereza completamente el codo',
    },
    {
      en: 'Grip, i.e. turn doorknob or shake hands',
      es: 'Agarra, i.e. agarrar la manilla de la puerta o un apretón de manos',
    },
    { en: 'Lift weight', es: 'Levantar pesas' },
  ],
  arm: [
    { en: 'Touch your shoulder', es: 'Toca tu hombro' },
    { en: 'Reach overhead ', es: 'Alcance por encima de tu cabeza' },
    { en: 'Reach behind your back', es: 'Alcance detrás de tu espalda' },
    {
      en: 'Reach across your body',
      es: 'Alcance diagonalmente a través del cuerpo',
    },
    { en: 'Move your head & neck', es: 'Mueve tu cabeza & cuello' },
    {
      en: 'Workstation use (prolonged look down)',
      es: 'Uso de la estación de trabajo (mirada prolongada hacia abajo)',
    },
    { en: 'Lay on your shoulder', es: 'Acuéstate sobre tu hombro' },
  ],
  hand: [
    { en: 'Touch your hand or wrist', es: 'Toca tu mano o muñeca' },
    {
      en: 'Flex or extend your wrist or hand',
      es: 'Flexiona o extiende la muñeca o la mano',
    },
    { en: 'Pinch with your fingers', es: 'Pellizca con tus dedos' },
    {
      en: 'Grip, i.e. turn doorknob or shake hands',
      es: 'Agarrar- abrir una puerta o estrechar la mano',
    },
  ],
  head: [
    { en: 'Touch your head or face', es: 'Toca tu cabeza o cara' },
    {
      en: 'Workstation use (prolonged look down)',
      es: 'Uso de la estación de trabajo (mirada prolongada hacia abajo)',
    },
    { en: 'Move your head & neck', es: 'Mover la cabeza y el cuello' },
    { en: 'Bend or lean forward', es: 'Inclínate hacia adelante' },
    { en: 'Stress', es: 'Estrés' },
    { en: 'Sleep', es: 'Dormir' },
    { en: 'Cough or sneeze', es: 'toser o estornudar' },
    { en: 'Chew food', es: 'Masticar' },
    { en: 'Light or sound', es: 'Luz o sonido' },
  ],
  fullSpine: [
    { en: 'Move your head & neck', es: 'Mover la cabeza y el cuello' },
    {
      en: 'Workstation use (prolonged look down)',
      es: 'Uso de la estación de trabajo (mirada prolongada hacia abajo)',
    },
    {
      en: 'Overhead work',
      es: 'Actividades que requieren movimientos por encima de tu cabez a',
    },
    { en: 'Breathe', es: 'Respira' },
    { en: 'Cough or sneeze', es: 'toser o estornudar' },
    { en: 'Sitting or car rides', es: 'Sentado o paseos en carro' },
    {
      en: 'Get in and out of a vehicle',
      es: 'Entrar y salir de un vehículo',
    },
    { en: 'Twist or bend', es: 'Girar o doblar' },
    { en: 'Stand or walk', es: 'Pararse o caminar' },
    { en: 'Arise after sitting', es: 'Levántate después de sentarte' },
    { en: 'Sleep', es: 'Dormir' },
  ],
  all: [{ en: 'Heavy activity', es: 'Actividad pesada' }],
};

const options = {};

export const allAggravatesOptions = Object.values(aggravates).reduce(
  (acc: { display: string; id: string }[], curr: { en: string; es: string }[]) => {
    // Add index signature to options to avoid implicit 'any' error
    const opts = options as { [key: string]: boolean };

    for (const item of curr) {
      if (!opts[item.en]) {
        opts[item.en] = true;
        acc.push({
          display: item.en,
          id: item.en,
        });
      }
    }

    return acc;
  },
  []
);
